
/**
 * Check if given element is a mark made by UnderlineMe
 */
exports = module.exports = function (e) {
  var el = null;
  el = e;
  if (el.tagName !== 'SPAN') {
    return false;
  }
  if (el.classList.contains('underlineme-mark')) {
    return el;
  } else {
    return false;
  }
}